import "./ImageBox.css"

export default function ImageBox() {
    return (
        <div className="image-box-container">
            <img className="image-box-image" src={require('../../assets/images/e450988c-8899-40bd-a92f-1dd09314eecd.JPG')} alt="Image1" />
            <img className="image-box-image" src={require('../../assets/images/702bf3e8-150d-45f0-89ef-ef27388470b8.JPG')} alt="Image1" />
            <img className="image-box-image" src={require('../../assets/images/81d35f11-c8e6-4266-b954-82336bf3b51c.JPG')} alt="Image1" />
            <img className="image-box-image" src={require('../../assets/images/e16c7982-c11f-4235-8919-eb15f30eedd4.JPG')} alt="Image1" />
            <img className="image-box-image" src={require('../../assets/images/610d330c-f56a-4e1e-93ea-cf8150410610.JPG')} alt="Image1" />
            <img className="image-box-image" src={require('../../assets/images/45ac321e-84a2-4103-862c-217b913b58ac.JPG')} alt="Image1" />
            <img className="image-box-image" src={require('../../assets/images/3fd55197-e46e-4557-a092-22b0682c6533.JPG')} alt="Image1" />
            <img className="image-box-image" src={require('../../assets/images/ca8d3bcf-52eb-4df2-a338-d243d7a0214d.JPG')} alt="Image1" />
            <img className="image-box-image" src={require('../../assets/images/d9b85104-8db2-4b0d-96f4-5584f7ed09a9.JPG')} alt="Image1" />
        </div>
    )
}